export const getDefaultValues = (data) => ({
  MediaRewardsTimeCount: data?.MediaRewardsTimeCount || undefined,
  MeidaRewardsTransactionAmountTypeID: data?.MeidaRewardsTransactionAmountTypeID || '1',
  MeidaRewardsValue: data?.MeidaRewardsValue || undefined,
  MediaRewardsScore: data?.MediaRewardsScore || undefined,
  MediaRewardsClubPoint: data?.MediaRewardsClubPoint ?? undefined,
  MediaRewardsUserLevel: data?.MediaRewardsUserLevel ?? undefined,
});
